<template>
    <li class="bill-item">
        <div class="bill-item-about">
            <span class="bill-item-amount">{{ item.quantity }} x</span>
            <div class="bill-item-name-group">
                <div class="bill-item-name" :class="{ paid: isPaid }">{{ item.product.name }}</div>
                <ul class="bill-item-subitem-list" v-for="subitem in item.subproducts" :key="subitem.id">
                    <li class="bill-item-subitem" :class="{ paid: isPaid }">
                        <span class="bill-item-subitem-quantity">+ {{ subitem.quantity }} x</span>
                        <span class="bill-item-subitem-name">{{ subitem.product.name }}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div>{{ sumPrice }} zł</div>
    </li>
</template>

<script>
export default {
    name: "CartItemBill",
    props: {
        item: { type: Object, required: true },
        isPaid: Boolean,
    },
    data() {
        return {}
    },
    computed: {
        sumPrice() {
            const itemPrice = this.item.product.price * this.item.quantity;
            const subitemPrice = this.item.subproducts.reduce((sum, val) => {
                return sum + val.product.price * val.quantity;
            }, 0)
            return itemPrice + subitemPrice;
        }
    },
}
</script>

<style lang="scss" scoped>
@import "src/scss/assets/variables";

ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
}

.bill-item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    padding: 10px;

    font-weight: 510;
    font-size: 14px;

    color: black;
}

.bill-item-about {
    display: flex;
}

.bill-item-amount {
    flex-shrink: 0;

    margin-right: 16px;

    color: $color_violet_electric;
}

.bill-item-subitem-list {
    font-weight: 400;
    font-size: 14px;

    color: $color_dove_gray;

    .bill-item-subitem {
        display: flex;

        .bill-item-subitem-quantity {
            flex-shrink: 0;

            margin-right: 10px;
        }
    }
}

.paid {
    text-decoration: line-through;

    color: $color_silver;
}
</style>